import { Injectable, inject } from "@angular/core"
import { Functions, httpsCallableData } from "@angular/fire/functions"
import { Observable } from "rxjs"

// export const apiserver = (path, data=null):Observable<any> =>{
//   // return httpsCallableData(getFunctions(undefined, 'europe-west1'), path, { timeout: 60_000 })(data)
//   return httpsCallableData(getFunctions(), path, { timeout: 60_000 })(data)
// }

@Injectable({
  providedIn: 'root'
})
export class ApiServerService {
  functions: Functions = inject(Functions);
  constructor(){
  }

  call = (path, data=null):Observable<any> =>{
    return httpsCallableData(this.functions, path, { timeout: 60_000 })(data)
  }


  search = (options: SearchModel | Array<SearchModel>) =>{
    const query = Array.isArray(options)? {queries:options} : options; 
    return this.call('api/search', query);
  }

  getIp = () => this.call('api/get/ip');

}


export interface SearchModel {
  index: string;
  body: Object
}

//TODO HAcer manejo genérico de errores (ver ejemplo utils-api)
export interface ApiError{
  code: string;
  details: any;
  message: string;

}

export const  API_ERROR_CODES = [
  'invalid-argument',
  'unauthenticated',
  'permission-denied',
  'not-found',
  'already-exists',
  'failed-precondition',
  'internal',
  'unimplemented',
  'unavailable',
  'deadline-exceeded'
]
export const API_SERVICES = ['functions']

export const getApiErrorCode = (code)=>code.split('/')[1];